import React from 'react';
import { useField } from 'hooked-form';
import InputField from '../InputField';
var StringField = function (_a) {
    var id = _a.id, name = _a.name, label = _a.label, placeholder = _a.placeholder, disabled = _a.disabled, validate = _a.validate, className = _a.className;
    var _b = useField(name, validate), _c = _b[0], onChange = _c.onChange, onBlur = _c.onBlur, onFocus = _c.onFocus, _d = _b[1], value = _d.value, touched = _d.touched, error = _d.error;
    return (React.createElement(InputField, { id: id, label: label, value: value, placeholder: placeholder || label, onChange: onChange, onBlur: onBlur, onFocus: onFocus, input: { disabled: disabled, name: name }, className: className, error: touched && error ? error : undefined }));
};
export default StringField;
//# sourceMappingURL=StringField.js.map